module.exports = __webpack_public_path__ + "assets/img/block-left-ec20b1ed.png";